export default "__VITE_ASSET__CCtEoZBX__"